import { RootState } from "../../../redux-store";

export const selectIsOpen = (state: RootState) =>
  state.app.equipmentTypeDialog.open;

export const selectInitialFormData = (state: RootState) =>
  state.app.equipmentTypeDialog.initialFormData;
